// Shared verbatim with server/src/services/recomputeDays.ts.
// If you change this file, mirror the change server-side.

export type Stage = "warmup" | "sales" | "close";

export interface DaySeed {
  id: string;
  stage: Stage;
  customLabel?: string | null;
  sortOrder?: number;
}

export interface DayLabeled extends DaySeed {
  weekday: string;
  date: string;
  dayNum: string;
  stageLabel: string;
  isToday: boolean;
  isoDate: string;
}

const WEEKDAYS_RU = [
  "Воскресенье",
  "Понедельник",
  "Вторник",
  "Среда",
  "Четверг",
  "Пятница",
  "Суббота",
];
const MONTHS_RU = [
  "янв",
  "фев",
  "мар",
  "апр",
  "май",
  "июн",
  "июл",
  "авг",
  "сен",
  "окт",
  "ноя",
  "дек",
];

// Format YYYY-MM-DD in the browser's local timezone. Using toISOString() would
// silently convert to UTC and break for anyone east/west of UTC enough to cross
// the date boundary at local midnight.
function toLocalIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function recomputeDays(
  days: DaySeed[],
  d1StartDateIso: string,
  todayIso?: string,
): DayLabeled[] {
  const d1Idx = days.findIndex((d) => d.stage === "sales");
  const d1Real = d1Idx >= 0 ? d1Idx : 0;

  // Accept either YYYY-MM-DD or a full ISO datetime; normalize to date-only.
  const d1Date = d1StartDateIso.slice(0, 10);
  const start = new Date(`${d1Date}T00:00:00`);
  const todayStr = todayIso ?? toLocalIsoDate(new Date());

  return days.map((d, i) => {
    const offset = i - d1Real;
    const dt = new Date(start);
    dt.setDate(start.getDate() + offset);
    const iso = toLocalIsoDate(dt);
    const weekday = WEEKDAYS_RU[dt.getDay()]!;
    const date = `${dt.getDate()} ${MONTHS_RU[dt.getMonth()]}`;
    const dayNum =
      offset === 0 ? "1" : offset > 0 ? String(offset + 1) : String(offset);
    const stageDefaults: Record<Stage, string> = {
      warmup: offset === -1 ? "Финальный прогрев" : "Прогрев",
      sales: offset === 0 ? "Эфир · День 1" : `Эфир · День ${offset + 1}`,
      close: "Дожим",
    };

    return {
      ...d,
      weekday,
      date,
      dayNum,
      stageLabel: d.customLabel || stageDefaults[d.stage] || d.stage,
      isToday: iso === todayStr,
      isoDate: iso,
    };
  });
}
